import React from 'react'

export default function LandingPage() {
  return (
    <main>
        <h1>LANDING PAGE</h1>
    </main>
  )
}
